import { cx } from "@emotion/css";
import { useTranslation } from "react-i18next";
import routing from "routing";
import { hasLimitedAccess } from "src/helpers/getPermissions";
import { ExamTypes } from "src/types/enums";
import PickerItems from "src/images/Icons/newIcons/itemsList.svg";
import ExamIcon from "src/images/Icons/newIcons/navigation/exams.svg";
import PickerNewItem from "src/images/Icons/newIcons/newItem.svg";

import { Header } from "../../../Main/ExamsBox/ExamsBox";
import { DefaultPicker } from "./DefaultPicker";

export function ExamsPicker() {
	const { t } = useTranslation();

	return (
		<DefaultPicker
			Header={
				<Header
					title={t("contentPicker.exam.title")}
					icon={<ExamIcon className={cx("icon-super-big icon-primary")} />}
					withBackButton
				/>
			}
			boxes={[
				{
					title: t("contentPicker.exam.create.title"),
					subtitle: t("contentPicker.exam.create.subtitle"),
					path: hasLimitedAccess()
						? `${routing.paths.createExam}?type=${ExamTypes.BASIC}`
						: routing.paths.pickExamType,
					submitText: t("commands.create"),
					Icon: PickerNewItem,
				},
				{
					title: t("contentPicker.exam.list.title"),
					subtitle: t("contentPicker.exam.list.subtitle"),
					path: routing.paths.examsList,
					submitText: t("commands.browse"),
					Icon: PickerItems,
				},
			]}
		/>
	);
}
